import { Navigate } from 'react-router-dom'
import { useFeatures } from './FeatureFlags'
import { ROLES, useAllowed, useIsRoleStaff } from './Capabilities'

/**
 * Where `/team-tools` lands.
 *
 * It was always the dashboard, which is deposit and sales figures behind the
 * role flags. Somebody holding only a capability granted in the admin -- an
 * outside community manager -- would land on a 403 there, so they are sent to
 * the first screen they were actually given instead.
 */
export const TeamToolsHome = () => {
    const isRoleStaff = useIsRoleStaff()
    const { isLoading } = useFeatures()
    const autoMod = useAllowed(ROLES.staff, 'view_anticheat')
    const tournaments = useAllowed(ROLES.marketing, 'manage_tournaments')
    const servers = useAllowed(ROLES.marketingOrDeveloper, 'view_servers')
    const players = useAllowed(ROLES.marketing, 'view_players')

    if (isRoleStaff) return <Navigate replace to='dashboard' />
    // The grant list is still on its way; deciding now would bounce a
    // community manager to the wrong screen and then again to the right one.
    if (isLoading) return null
    if (autoMod) return <Navigate replace to='accounts/auto-mod' />
    if (tournaments) return <Navigate replace to='tournaments' />
    if (servers) return <Navigate replace to='server-control' />
    if (players) return <Navigate replace to='accounts/users' />
    return (
        <div className='mx-auto mt-16 max-w-md border border-white border-opacity-20 p-6 text-center text-xs'>
            Nothing in Team Tools has been granted to this account yet.
        </div>
    )
}

/** Where `/team-tools/accounts` lands: the account list, or Auto Mod for somebody not given the list. */
export const AccountsHome = () => {
    const players = useAllowed(ROLES.marketing, 'view_players')
    const { isLoading } = useFeatures()
    if (players) return <Navigate to='users' replace />
    if (isLoading) return null
    return <Navigate to='auto-mod' replace />
}
